module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "col-md-12 info-bar",
    class: _vm.entity.banner
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-navigation-reservation"
  }, [_c('v-tabs', {
    attrs: {
      "fixed-tabs": ""
    }
  }, [_c('v-tabs-slider', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": "/my-reservations/upcoming"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" aankomende "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1), _vm._v(" "), _c('v-tab', {
    attrs: {
      "to": "/my-reservations/archive"
    }
  }, [_c('entity-text', {
    attrs: {
      "text": "personalPronounTwo"
    }
  }), _vm._v(" vorige "), _c('entity-text', {
    attrs: {
      "text": "voyages"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f12cd8e4"}!./src/templates/portal/reservations.html
// module id = 554
// module chunks = 1